import { useNavigate } from 'react-router-dom';
import { MobileView } from 'react-device-detect';
import { useAppContext, SET_SUNLIGHT } from '../context/AppContext';
import fullSun from '../images/ui_buttons/full_sun_button.png';
import filterSun from '../images/ui_buttons/filter_sun_button.png';
import fullShade from '../images/ui_buttons/full_shade_button.png';
import backButton from '../images/ui_buttons/back_button.png';
import SunlightSelectorMobile from './SunlightSelector.mobile';
import '../css/card.css';

const SunlightSelector = () => {
	const { state, dispatch } = useAppContext();
	const { style, sunlight } = state.currentDesign || {};
	const navigate = useNavigate();

	// Navigate to the next screen
	/* const handleNext = () => {
		console.log(state);
		navigate('/garden-bed');
	}; */

	// Navigate to the previous screen
	const handleBack = () => {
		console.log(state);
		navigate('/style');
	};

	// Logic for choosing selected sunlight
	const handleSelectSunlight = (sunlightId) => {
		console.log('SunlightSelector received click on', sunlightId);
		dispatch({ type: SET_SUNLIGHT, payload: sunlightId });
    navigate('/garden-bed');
	};

	return (
		<>
			<MobileView>
				<SunlightSelectorMobile
					style={style}
					sunlight={sunlight}
					onSunlightSelect={handleSelectSunlight}
					onBack={handleBack}
				/>
			</MobileView>
			<div className='full-container'>
				<header>
					<button onClick={handleBack}>
						<img src={backButton} alt='Back' className='button-image' />
					</button>
					<h1>Level of Sunlight</h1>
					<div> </div>
					{/*
					<button
						onClick={handleNext}
						disabled={!isSelectionMade}
						className={`next-button ${isSelectionMade ? 'active' : 'inactive'}`}>
						<img src={nextButton} alt='Next' className='button-image' />
					</button>
					*/}
				</header>
				<div className='sunlight-body-container'>
					<div
						className={`sunlight-card-container ${
							sunlight === 'full_sun' ? 'selected' : ''
						}`}
						onClick={() => handleSelectSunlight('full_sun')}>
						<div className='sunlight-image-container'>
							<img src={fullSun} alt='Full Sun' className='sunlight-image' />
						</div>
						<h1>Full Sun</h1>
					</div>
					<div
						className={`sunlight-card-container ${
							sunlight === 'filter_sun' ? 'selected' : ''
						}`}
						onClick={() => handleSelectSunlight('filter_sun')}>
						<div className='sunlight-image-container'>
							<img src={filterSun} alt='Filter Sun' className='sunlight-image' />
						</div>
						<h1>Filter Sun</h1>
					</div>
					{style !== 'tropical' && style !== 'waterwise' && (
						<div
							className={`sunlight-card-container ${
								sunlight === 'full_shade' ? 'selected' : ''
							}`}
							onClick={() => handleSelectSunlight('full_shade')}>
							<div className='sunlight-image-container'>
								<img src={fullShade} alt='Full Shade' className='sunlight-image' />
							</div>
							<h1>Full Shade</h1>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default SunlightSelector;
